import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PetCardsVisibilityService {
  private hidePetCardsSubject = new BehaviorSubject<boolean>(false);
  hidePetCards$ = this.hidePetCardsSubject.asObservable();
  isHiddenFromRoute = false;
  isHiddenByUser = false;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.updateStateFromRoute();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateStateFromRoute();
    });
  }

  private updateStateFromRoute(): void {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const hidePetCards = route.snapshot?.data['hidePetCards'] ?? false;
    this.isHiddenFromRoute = hidePetCards;
    this.changeState();
  }

  toggle(): void {
    this.setHiddenByUser(!this.isHiddenByUser);
  }

  setHiddenByUser(hidden: boolean): void {
    if (this.isHiddenByUser === hidden) {
      return;
    }

    this.isHiddenByUser = hidden;
    this.changeState();
  }

  changeState() {
    this.hidePetCardsSubject.next(this.isHiddenFromRoute || this.isHiddenByUser);
  }

  getCurrentValue(): boolean {
    return this.hidePetCardsSubject.value;
  }
}
